/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type AptosMemeCoinInfo = {
    COINID: string;
    LOGO: string;
    NM: string;
    SB: string;
    AGE: string;
    PTAG: Array<string>;
    ASTTP: string;
    PRC: string;
    PRC5M: string;
    PRC1H: string;
    PRC6H: string;
    PRC24H: string;
    MKC: string;
    FDV: string;
    HD: string;
    PCT: AptosMemeCoinInfo.PCT;
    PST: AptosMemeCoinInfo.PST;
};

export namespace AptosMemeCoinInfo {

    export enum PCT {
        NATIVE = 'NATIVE',
        EMOJICOIN = 'EMOJICOIN',
        MEME = 'MEME',
        BRIDGED = 'BRIDGED',
        NONE = 'NONE',
    }

    export enum PST {
        VERIFIED = 'VERIFIED',
        RECOGNIZED = 'RECOGNIZED',
        UNVERIFIED = 'UNVERIFIED',
        BANNED = 'BANNED',
        INTERNAL_FA = 'INTERNAL_FA',
        LP = 'LP',
        NONE = 'NONE',
    }


}

